var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopiar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3264 7.28589H10.2824C9.77021 7.28774 9.27968 7.49293 8.9187 7.85635C8.55772 8.21977 8.35584 8.71166 8.35743 9.22389V19.3119C8.35743 20.3819 9.21943 21.2499 10.2824 21.2499H18.3264C18.8387 21.248 19.3292 21.0428 19.6902 20.6794C20.0511 20.316 20.253 19.8241 20.2514 19.3119V9.22389C20.2514 8.15389 19.3894 7.28589 18.3264 7.28589Z",
    stroke: "#FAAC58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.642 7.286V4.688C15.642 4.174 15.439 3.681 15.078 3.318C14.8999 3.1382 14.6879 2.99545 14.4543 2.89796C14.2207 2.80048 13.9702 2.75019 13.717 2.75H5.67305C5.16305 2.75 4.67305 2.954 4.31305 3.318C3.95131 3.68222 3.74821 4.17467 3.74805 4.688V14.776C3.74805 15.29 3.95105 15.783 4.31205 16.146C4.67305 16.51 5.16205 16.714 5.67305 16.714H8.35805",
    stroke: "#FAAC58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopiar);
export default __webpack_public_path__ + "static/media/Copiar.88b1f371f1f09d16b76f7bbdbf00c4d6.svg";
export { ForwardRef as ReactComponent };